import { useWorldExperience } from "../world/WorldExperienceProvider";
import type { WorldMode } from "../world/types";

const MODES: readonly { value: WorldMode; label: string }[] = [
  { value: "static", label: "Static" },
  { value: "balanced", label: "Balanced" },
  { value: "off", label: "Off" },
];

export function HomeWorldControls() {
  const { mode, capability, setPreference } = useWorldExperience();
  return (
    <div className="home-world-controls" aria-label="Homepage world quality">
      <span>World</span>
      <div>
        {MODES.filter(
          (item) => item.value !== "balanced" || capability.balancedAllowed,
        ).map((item) => (
          <button
            key={item.value}
            type="button"
            aria-pressed={mode === item.value}
            onClick={() => setPreference(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
